<div *ngIf="loaderService.loader" class="loader-container">
    <div class="mini-float-loader">
        <span class="loader"></span>
        <span class="sp-title">{{ loaderService.title }}</span>
    </div>
</div>